/**
 * Welcome di apertura del Personal Assistant.
 *
 * Effimero, lato client: mostrato nello stato vuoto di ogni nuova chat,
 * NON persistito e NON inviato all'LLM. Il saluto orario usa il fuso del
 * browser dell'utente loggato.
 */

export interface PaWelcomeCopy {
  /** Saluto + nome utente, es. "Buongiorno, Mario!". */
  heading: string;
  /** Presentazione dell'assistente, es. "Sono Jarvis, il tuo assistente personale.". */
  intro: string;
  /** Cosa fa: descrizione dell'agente se presente, altrimenti fallback generico. */
  body: string;
}

export interface PaWelcomeParams {
  assistantName: string;
  assistantDescription?: string | null;
  userFirstName?: string | null;
  /** Iniettabile nei test; default = ora corrente. */
  date?: Date;
}

/**
 * Saluto in base all'ora locale: "Buongiorno" dalle 05:00 alle 12:59,
 * "Buonasera" altrimenti (come richiesto: due sole varianti).
 */
export function getDayGreeting(date: Date = new Date()): string {
  const hour = date.getHours();
  return hour >= 5 && hour < 13 ? 'Buongiorno' : 'Buonasera';
}

const DEFAULT_BODY = 'Come posso aiutarti oggi? Chiedimi quello che ti serve.';

export function buildPaWelcome(params: PaWelcomeParams): PaWelcomeCopy {
  const greeting = getDayGreeting(params.date);
  const name = params.userFirstName?.trim();
  const assistant = params.assistantName.trim() || 'il tuo assistente';
  const description = params.assistantDescription?.trim();
  return {
    heading: name ? `${greeting}, ${name}!` : `${greeting}!`,
    intro: `Sono ${assistant}, il tuo assistente personale.`,
    body: description && description.length > 0 ? description : DEFAULT_BODY,
  };
}
